// extracted by mini-css-extract-plugin
module.exports =  {"collapse":"ZHn5qF0271j02epnlgbD","content":"LkhtJBySXdNJWdCLSHA1"};